export interface StartMenuOptions {
    onStart: () => void;
    onOptions: () => void;
    onReset: () => void;
}

export class StartMenu {
    private readonly root: HTMLElement;
    private readonly onStart: () => void;

    constructor({ onStart, onOptions, onReset }: StartMenuOptions) {
        this.root = document.getElementById('startMenu') as HTMLElement;
        this.onStart = onStart;

        document.getElementById('startMenuStartButton')!.addEventListener('click', () => this.start());
        document.getElementById('startMenuOptionButton')!.addEventListener('click', onOptions);
        document.getElementById('startMenuResetButton')!.addEventListener('click', onReset);
        document.getElementById('startMenuExitButton')!.addEventListener('click', () => {
            window.close();
        });
    }

    private start(): void {
        this.root.classList.add('is-hidden');
        this.onStart();
    }
}
